import React from 'react';
import { FaComments, FaUsers, FaLightbulb, FaStar, FaBookOpen } from 'react-icons/fa';

const SoftSkills = () => (
  <div className="flex flex-col pb-4 w-full space-y-4 dark:bg-opacity-25 dark:bg-gray-700 p-4 rounded-lg shadow-2xl relative backdrop-blur-sm mb-10 z-20 items-center md:items-start pr-3 md:mb-0">
    {/* Communication Skill */}
    <div className="w-full">
      <div className="flex justify-between items-center mb-1">
        <span className="text-gray-200 flex items-center">
          <FaComments className="mr-2" /> Communication
        </span>
        <span className="text-gray-200">90%</span>
      </div>
      <div className="relative w-full h-2 rounded-md overflow-hidden bg-gray-300 dark:bg-gray-700">
        <div
          className="absolute meter-bar top-0 left-0 h-full bg-green-500 dark:bg-blue-300 transition-width duration-1000"
          aria-valuenow="90"
          style={{ width: '0%' }}
        />
      </div>
    </div>

    {/* Teamwork Skill */}
    <div className="w-full">
      <div className="flex justify-between items-center mb-1">
        <span className="text-gray-200 flex items-center">
          <FaUsers className="mr-2" /> Teamwork
        </span>
        <span className="text-gray-200">80%</span>
      </div>
      <div className="relative w-full h-2 rounded-md overflow-hidden bg-gray-300 dark:bg-gray-700">
        <div
          className="absolute meter-bar top-0 left-0 h-full bg-green-500 dark:bg-blue-300 transition-width duration-1000"
          aria-valuenow="80"
          style={{ width: '0%' }}
        />
      </div>
    </div>

    {/* Problem Solving Skill */}
    <div className="w-full">
      <div className="flex justify-between items-center mb-1">
        <span className="text-gray-200 flex items-center">
          <FaLightbulb className="mr-2" /> Problem Solving
        </span>
        <span className="text-gray-200">85%</span>
      </div>
      <div className="relative w-full h-2 rounded-md overflow-hidden bg-gray-300 dark:bg-gray-700">
        <div
          className="absolute meter-bar top-0 left-0 h-full bg-green-500 dark:bg-blue-300 transition-width duration-1000"
          aria-valuenow="85"
          style={{ width: '0%' }}
        />
      </div>
    </div>

    {/* Leadership Skill */}
    <div className="w-full">
      <div className="flex justify-between items-center mb-1">
        <span className="text-gray-200 flex items-center">
          <FaStar className="mr-2" /> Leadership
        </span>
        <span className="text-gray-200">65%</span>
      </div>
      <div className="relative w-full h-2 rounded-md overflow-hidden bg-gray-300 dark:bg-gray-700">
        <div
          className="absolute meter-bar top-0 left-0 h-full bg-green-500 dark:bg-blue-300 transition-width duration-1000"
          aria-valuenow="65"
          style={{ width: '0%' }}
        />
      </div>
    </div>

    {/* Self-Learning Skill */}
    <div className="w-full">
      <div className="flex justify-between items-center mb-1">
        <span className="text-gray-200 flex items-center">
          <FaBookOpen className="mr-2" /> Self-Learning
        </span>
        <span className="text-gray-200">95%</span>
      </div>
      <div className="relative w-full h-2 rounded-md overflow-hidden bg-gray-300 dark:bg-gray-700">
        <div
          className="absolute meter-bar top-0 left-0 h-full bg-green-500 dark:bg-blue-300 transition-width duration-1000"
          aria-valuenow="95"
          style={{ width: '0%' }}
        />
      </div>
    </div>
  </div>
);

export default SoftSkills;
